export default __webpack_public_path__ + "static/why-tecalis_02-18dedcbc88c10cf3512fdee2a6f61ccc.png";